var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-img',{attrs:{"src":_vm.file,"fluid":"","alt":"Responsive image"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }